import { render } from "./TentangBIBPage.vue?vue&type=template&id=d06f86b0&scoped=true"
import script from "./TentangBIBPage.vue?vue&type=script&lang=js"
export * from "./TentangBIBPage.vue?vue&type=script&lang=js"

import "./TentangBIBPage.vue?vue&type=style&index=0&id=d06f86b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d06f86b0"]])

export default __exports__